/**
 * Executes function if user mouse down outside the HTML Element ref(s).
 *
 * Derived from ../../hooks/useOnOutsideMouseDown
 * Add mark event capability
 */

import { useEffect } from 'react';
import cn from '../Modal/Modal.css.json';
const markedEvents = new WeakSet();
export function markEvent(event) {
  markedEvents.add(event);
}
export function isEventMarked(event) {
  return markedEvents.has(event);
}
export const useOnOutsideMouseDown = (containerRef, onOutsideMouseDown) => {
  useEffect(() => {
    const onMouseDown = event => {
      if (isEventMarked(event)) return;
      const containerRefs = !Array.isArray(containerRef) ? [containerRef] : containerRef;
      for (const ref of containerRefs) {
        if (ref.current?.contains(event.target)) {
          return;
        }
      }
      const blockLayers = document.getElementsByClassName(cn.modalBlockLayer);
      if (blockLayers.length) {
        const topBlockLayer = blockLayers[blockLayers.length - 1];
        for (const ref of containerRefs) {
          if (ref.current && !topBlockLayer.contains(ref.current)) return;
        }
      }
      onOutsideMouseDown();
    };
    window.addEventListener('mousedown', onMouseDown);
    return () => {
      window.removeEventListener('mousedown', onMouseDown);
    };
  }, [containerRef, onOutsideMouseDown]);
};
//# sourceMappingURL=useOnOutsideMouseDown.js.map